import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resellers',
  templateUrl: './resellers.component.html',
  styleUrls: ['./resellers.component.scss']
})
export class ResellersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
